import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useActions } from '../../../../hooks/useActions';
import { useDebounce } from '../../../../hooks/useDebounce';
import { IEditKEOrganizationSubscriptionModel } from '../../../../models/interfaces/Subscription/KidnapAndExtortion/EditKEOrganizationSubscriptionModel';
import { EditProductSubscriptionPageParamsType } from '../../../../models/types/RoutePath';
import { loadKESubscriptionSummary } from '../../../../store/saga-slices/subscriptions/kidnapAndExtortion';
import { ILoadKESubscriptionSummary } from '../../../../store/saga-slices/subscriptions/kidnapAndExtortion/models';

type SummaryLoaderProps = {
  values: IEditKEOrganizationSubscriptionModel;
};

const SummaryLoader = ({ values }: SummaryLoaderProps) => {
  const { organizationId } = useParams<EditProductSubscriptionPageParamsType>();

  const LoadSubscriptionSummary = useActions(loadKESubscriptionSummary);
  const { debounce } = useDebounce();

  useEffect(() => {
    if (!values?.pricing?.membershipPlans) {
      return;
    }

    const payload: ILoadKESubscriptionSummary = {
      data: values?.pricing?.membershipPlans,
      organizationId,
    };

    debounce(() => LoadSubscriptionSummary(payload), 300);
  }, [
    LoadSubscriptionSummary,
    debounce,
    organizationId,
    values?.pricing?.membershipPlans,
  ]);

  return <></>;
};

export default SummaryLoader;
